import React, {Component} from 'react';
import {BreadCumb, DataTables, NavBar,TimeOut} from "../../components";
import config from "../../config";
import moment from "moment";
import {ApiClient} from "../../libs/apiClient";
import {DISPATCH_ID, SERVICE_RESPONSE} from "../../libs/utils/Const";
import {connect} from "react-redux";
const apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Serie", value: true },
    { title: "Num.Doc", value: true },
    { title: "Proveedor", value: true },
    { title: "Nombre", value: true },
    { title: "Fletero", value: true },
    { title: "Nombre", value: true },
    { title: "Fecha Cont.", value: true },
    { title: "Comentarios", value: true },
    { title: "Total", value: true },
    { title: "Estatus", value: true }
];

class LandedCosts extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }
    }

    async componentDidMount () {
        // localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liGoodsReceipt");
        let today = moment(new Date()).format('YYYYMMDD');

        let date = {
            dateInit: today,
            dateFinal: today,
        }

        await this.callDocumentsListService(date);
    }

    callDocumentsListService = async newDate => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            switch1: newDate.docStatus || '---',
            table: "OIPF",
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--'
        };

        enableSpinner(true);
        const landedCostsRes = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if (landedCostsRes.status === SERVICE_RESPONSE.SUCCESS) {

            // const dataSerie = {
            //     docType: "69",
            //     docSubType: "--"
            // };

            // enableSpinner(true);
            // const seriesResponse = await apiClient.getSeries(dataSerie);
            // console.log('Gus>SERIES',seriesResponse);
            // enableSpinner(false);

            // const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            // let ValidateSeries = user.U_FMB_ValidateSeriesOPDN ? user.U_FMB_ValidateSeriesOPDN : "";

            // if (!user || ValidateSeries == "") {
            //     showAlert({
            //         type: 'warning',
            //         timeOut: 5000,
            //         message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
            //     });

            //     this.setState({
            //         data: [],
            //     });
            //     return;
            // }

            // let seriesUsers = ValidateSeries.split("|");

            // console.log('Gus>seriesUsers',seriesUsers);

            // let newArraySeries = [];

            // seriesUsers.map(serieUser => {
            //     seriesResponse.data.map(serieResponse => {
            //         if (serieResponse.Series == serieUser) {
            //             newArraySeries.push(serieResponse);
            //         }
            //     })
            // })

            // if (newArraySeries.length === 0) {
            //     showAlert({
            //         type: 'warning',
            //         timeOut: 5000,
            //         message: "El usuario no tiene serie permitida de escritura y lectura"
            //     });
            //     return;
            // }

            // let newDocumentsfilterSeries = [];

            // landedCostsRes.data.map(document => {
            //     newArraySeries.map(serie => {
            //         console.log('Gus>document.SeriesCode',document.SeriesCode);
            //         if (document.SeriesCode == serie.Series) {
            //             newDocumentsfilterSeries.push(document);
            //         }
            //     })
            // });

            // console.log('Gus>newDocumentsfilterSeries',newDocumentsfilterSeries);

            // this.setState({
            //     data: newDocumentsfilterSeries,
            // });
            
            this.setState({
                data: landedCostsRes.data,
            });
            
            return;
        }
    }

    searchDocuments = async date => {
        await this.callDocumentsListService(date);
    };

    render() {
        const {headers, data ,_user} = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user}/>
                <BreadCumb subitem1={'PRECIOS DE ENTREGA'} url1={'#'}/>
                <TimeOut/>
                <div style={{marginLeft: "4rem", marginBottom: "12rem"}}>

                    <h2 className="md-display-1">
                        <a id="linkOrdProv" className="text-muted">
                            &nbsp;PRECIOS DE ENTREGA
                        </a>
                    </h2>
                    <DataTables headers={headers} view={"landedCosts"} data={data} search={this.searchDocuments} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {notificationReducer: store.NotificationReducer};
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value})
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LandedCosts);